import { Type } from '@angular/core';
import { ConfigurationId } from '@types';
import { DistributionComponent } from './distribution/distribution.component';
import { PremiumDiscountAnalysisComponent } from './premium-discount-analysis/premium-discount-analysis.component';
import { LiquidAssetsComponent } from './liquid-assets/liquid-assets.component';
import { PricingDistributionDisplayComponent } from './pricing-distribution-component.interface';
import { PremiumDiscountNavVivComponent } from './pricing/premium-discount-nav-viv/premium-discount-nav-viv.component';
import { PricingComponent } from './pricing/pricing.component';
import { ShadowNavComponent } from './shadow-nav/shadow-nav.component';
import { DistributionChartComponent } from './distribution-chart/distribution-chart.component';

export class PricingDistributionConfig {
  static readonly FUND_DISTRIBUTIONS = new PricingDistributionConfig(
    'Distribution',
    DistributionComponent,
    ConfigurationId.GW
  );
  static readonly FUND_PRICING = new PricingDistributionConfig(
    'Price',
    PricingComponent,
    ConfigurationId.GW
  );
  static readonly PREMIUM_DISCOUNT_NAV_TO_VIV = new PricingDistributionConfig(
    'Premium/Discount NAV to VIIV',
    PremiumDiscountNavVivComponent,
    ConfigurationId.GW
  );
  static readonly PREMIUM_DISCOUNT_ANALYSYS = new PricingDistributionConfig(
    'Premium Discount Analysis',
    PremiumDiscountAnalysisComponent,
    ConfigurationId.GW
  );
  static readonly LIQUID_ASSETS = new PricingDistributionConfig(
    'Liquid Assets',
    LiquidAssetsComponent,
    ConfigurationId.GW
  );
  static readonly SHADOW_NAV = new PricingDistributionConfig(
    'Historical Shadow Nav',
    ShadowNavComponent,
    ConfigurationId.GW
  );
  static readonly DISTRIBUTION_CHART = new PricingDistributionConfig(
    'Distribution Chart',
    DistributionChartComponent,
    ConfigurationId.GW
  );

  static readonly DISTRIBUTION_WITH_NAV = new PricingDistributionConfig(
    'Distribution Chart with NAV',
    DistributionChartComponent,
    ConfigurationId.GW
  );

  static allConfigs: PricingDistributionConfig[] = [
    PricingDistributionConfig.FUND_DISTRIBUTIONS,
    PricingDistributionConfig.FUND_PRICING,
    PricingDistributionConfig.PREMIUM_DISCOUNT_NAV_TO_VIV,
    PricingDistributionConfig.PREMIUM_DISCOUNT_ANALYSYS,
    PricingDistributionConfig.LIQUID_ASSETS,
    PricingDistributionConfig.SHADOW_NAV,
    PricingDistributionConfig.DISTRIBUTION_CHART,
    PricingDistributionConfig.DISTRIBUTION_WITH_NAV,
  ];

  // returns matching config or undefined
  static getConfig(
    key: string,
    configurationName: ConfigurationId
  ): PricingDistributionConfig {
    return this.allConfigs.find((config: PricingDistributionConfig): boolean =>
      config.configurationName
        ? config.key === key && config.configurationName === configurationName // if config is GW or ETF specific,make sure it matches
        : config.key === key
    ); // otherwise just match on key
  }

  private constructor(
    private readonly key: string,
    public readonly component: Type<PricingDistributionDisplayComponent>,
    public readonly configurationName?: ConfigurationId
  ) {}
}
